import {
  Modifier as CalendarModifier,
  RangeModifier as CalendarRangeModifier,
} from '@erecruit/ui-kit/src/molecules/Calendar/Calendar';

export const getDefaultValue = <T extends { id: number }>(collection: T[]) =>
  collection?.length === 1 ? collection[0].id : undefined;

/**
 * Returns key for given date or date range.
 * Key is represented as string representation of date or date range.
 * @param value Date or date range
 */
export function getKey(value: CalendarModifier): string {
  if (Object.keys(value as object).length === 0) {
    // Date
    return (value as Date).toDateString();
  } else {
    const range = value as CalendarRangeModifier;
    return `${range.from.toDateString()}-${range.to.toDateString()}`;
  }
}
